import script from "./IonicMobileNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./IonicMobileNavBar.vue?vue&type=script&setup=true&lang=js"

import "./IonicMobileNavBar.vue?vue&type=style&index=0&id=81f04fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81f04fd4"]])

export default __exports__